export default __webpack_public_path__ + "static/media/IMG_3908 - Copy.449122ca.jpg";